<div class="column-settings flex column h-100">
  <div class="column-settings__card flex column h-100 p-6 bg-white radius-3">
    <!-- Header -->
    <div class="column-settings__header flex align-flex-start">
      <div class="column-settings__heading flex column">
        <h3 class="column-settings__title m-0">{{ "Reports.ColumnSettings" | translate }}</h3>
        <p class="column-settings__subtitle m-0 text-600">{{ subtitleKey | translate }}</p>
      </div>
      <button type="button" class="column-settings__close flex align-center justify-center cursor-pointer text-700 p-0" (click)="discardChanges(); closeDrawer()">
        <app-icon name="outline-cross" size="xxs"></app-icon>
      </button>
    </div>

    <div class="column-settings__body flex column py-3 brd-t brd-b brd-200" *ngIf="form">
      <!-- Search -->
      <div class="column-settings__search flex align-center bg-50 brd brd-200 radius-2">
        <app-icon name="search" size="xs" class="text-primary-300"></app-icon>
        <input
          type="text"
          class="column-settings__search-input"
          [ngModel]="searchTerm"
          (ngModelChange)="onSearchChange($event)"
          [placeholder]="'Buttons.Search' | translate"
        />
      </div>

      <!-- Columns lists: the only scrolling area; header, search and footer stay put. -->
      <div class="column-settings__lists scrollable scrollable--y flex column">
        <div class="column-settings__dynamic flex column" *ngIf="!hideDynamicFieldsToggle">
          <div class="toggle-header flex align-center justify-space-between">
            <mat-slide-toggle color="primary" [(ngModel)]="isDynamicFieldsVisible" (change)="onToggleShowDynamicFields($event)">
              {{ 'Reports.ShowDynamicFields' | translate }}<span *ngIf="dynamicFields.length">({{ dynamicFields.length }})</span>
            </mat-slide-toggle>
            <button mat-icon-button (click)="toggleExpanded()" [class.arrow-rotated]="isExpanded" [disabled]="!dynamicFields.length">
              <app-icon name="down-arrow-bold" class="cursor-pointer"></app-icon>
            </button>
          </div>
          <div *ngIf="isExpanded">
            <div
              draggable="true"
              class="column-settings__row flex align-center radius-2 py-2 px-3"
              *ngFor="let field of dynamicFields; let i = index"
              (dragstart)="draggedDynamicOrder = i"
              (dragover)="draggedOverDynamicOrder = i"
              (dragend)="swapDynamicFields()"
            >
              <span class="column-settings__grip-slot flex align-center justify-center">
                <app-icon name="ico-grip" class="column-settings__grip"></app-icon>
              </span>
              <span class="column-settings__row-label">{{ field }}</span>
            </div>
          </div>
        </div>

        <!-- Added columns -->
        <div class="column-settings__section flex column w-100">
          <div class="column-settings__section-head flex align-center justify-space-between p-1">
            <span class="column-settings__section-title text-uppercase text-400">{{ "Reports.AddedColumns" | translate }}</span>
            <span class="column-settings__badge bg-white text-700 brd brd-200">{{ form.length }}</span>
          </div>
          <ng-container *ngFor="let control of form.controls; let i = index; trackBy: trackByControlValue">
            <div
              class="column-settings__row flex align-center radius-2 py-2 px-3"
              *ngIf="matchesSearch(control.value)"
              [draggable]="!isLocked(control.value)"
              (dragstart)="draggedColumnOrder = i"
              (dragover)="draggedOverColumnOrder = i"
              (dragend)="swapOrder()"
            >
              <span class="column-settings__grip-slot flex align-center justify-center">
                <app-icon *ngIf="!isLocked(control.value)" name="ico-grip" class="column-settings__grip"></app-icon>
              </span>
              <span class="column-settings__row-label" [class.column-settings__row-label--muted]="isLocked(control.value)">
                {{ rawLabels[control.value] || ("Reports." + keys[control.value] | translate) }}
              </span>
              <button
                *ngIf="!isLocked(control.value)"
                type="button"
                class="column-settings__action column-settings__action--remove flex align-center justify-center cursor-pointer radius-2 bg-warn-lighter text-warn"
                (click)="removeColumn(control.value, i)"
              >
                <app-icon name="outline-minus" size="sm"></app-icon>
              </button>
              <app-icon *ngIf="isLocked(control.value)" name="outline-lock" class="column-settings__lock"></app-icon>
            </div>
          </ng-container>
        </div>

        <!-- Available columns -->
        <div class="column-settings__section flex column w-100" *ngIf="availableColumns.length">
          <div class="column-settings__section-head flex align-center justify-space-between p-1">
            <span class="column-settings__section-title text-uppercase text-400">{{ "Reports.AvailableColumns" | translate }}</span>
          </div>
          <div class="column-settings__row flex align-center radius-2 py-2 px-3" *ngFor="let option of availableColumns; trackBy: trackByOptionKey">
            <span class="column-settings__grip-slot flex align-center justify-center"></span>
            <span class="column-settings__row-label">
              {{ rawLabels[option.key] || ("Reports." + option.value | translate) }}
            </span>
            <button
              type="button"
              class="column-settings__action column-settings__action--add flex align-center justify-center cursor-pointer radius-2 bg-50 text-700"
              (click)="addColumn(option.key)"
            >
              <app-icon name="outline-add" size="sm"></app-icon>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="footer-actions flex align-center justify-space-between pt-3">
      <button type="button" class="footer-btn text-800 py-2 px-3" (click)="resetOptions()">
        {{ "Reports.ResetToDefault" | translate }}
      </button>

      <div class="footer-actions__main flex align-center">
        <button type="button" class="footer-btn footer-btn--cancel text-800 brd brd-200 bg-white" (click)="discardChanges(); closeDrawer()">
          {{ "Buttons.Cancel" | translate }}
        </button>

        <button type="button" class="footer-btn footer-btn--apply text-white" (click)="applyChanges()">
          {{ "Buttons.Apply" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
